/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import config from 'config';

export function CatchReportAsyncException(
	target: object,
	propertyName: string,
	propertyDescriptor: PropertyDescriptor
): PropertyDescriptor {
	const originalMethod = propertyDescriptor.value;
	propertyDescriptor.value = async function (...args: any[]): Promise<any> {
		try {
			return await originalMethod.apply(this, args);
		} catch (error) {
			if (rollbar) {
				rollbar.error(error, args,  error?.data);
			}
			throw error;
		}
	};

	return propertyDescriptor;
}

export function CatchReportException(
	target: object,
	propertyName: string,
	propertyDescriptor: PropertyDescriptor
): PropertyDescriptor {
	const originalMethod = propertyDescriptor.value;
	propertyDescriptor.value = function (...args: any[]): any {
		try {
			return originalMethod.apply(this, args);
		} catch (error) {
			if (rollbar) {
				rollbar.error(error, args);
			}
			throw error;
		}
	};

	return propertyDescriptor;
}

const rollbarConfig = {
	accessToken: config.PUBLIC_ROLLBAR_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: global['rollbarIgnore'],
	payload: {
		environment: config.environment
	}
};

const rollbar: any =
	global && global['rollbar'] && global['rollbarIgnore'] ? new global['rollbar'](rollbarConfig) : null;
